import React, { useState } from "react";
import { ReactComponent as RightArrow } from "../../../../../assets/svgs/rightArrow.svg";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-square.svg";
import { Button } from "antd";
import AddQuestion from "./AddQuestion";
import { useLocation, useNavigate } from "react-router-dom";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";

const EditDynamicForm = () => {
  const [addQuestion, setAddQuestion] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { data, formTitle, formId } = location.state || {};

  const handleSearch = (searchTerm) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    console.log(lowercasedTerm);
  };

  const handleBack = () => {
    navigate("/organization/dynamic-forms");
  };

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div className="mt-10">
        {addQuestion ? (
          <AddQuestion onCancel={() => setAddQuestion(false)} />
        ) : (
          <div>
            <div className="flex text-base font-light p-3">
              <p>Home</p>
              <span>
                <RightArrow />
              </span>
              <p>Form</p>
              <span>
                <RightArrow />
              </span>
              <TextStyles color="gradient">{formTitle}</TextStyles>
            </div>
            <div
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                height: "100%",
              }}
            >
              <div className="flex justify-between mx-8 my-2">
                <div className="  flex gap-14 my-auto">
                  <BackIcon onClick={handleBack} />

                  <SearchBar onSearch={handleSearch} />
                </div>
                <button className="text-lg font-light border-solid border-2 px-8 rounded-lg py-1">
                  Fliter
                </button>
              </div>

              <div className="flex justify-between mx-8 mt-14">
                <p className="text-sm font-medium text-gray-400">
                  SECTION NAME
                </p>
                <Button
                  type="primary"
                  style={{
                    background:
                      "linear-gradient(90deg, #3FC28A 0%, #00249B 100%)",
                    height: "40px",
                    //   width: "150px",
                    borderRadius: "10px",
                  }}
                  className="text-base font-light mb-4"
                  onClick={() => setAddQuestion(true)}
                >
                  + Add Question
                </Button>
              </div>
              {/* <div>{data}</div> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditDynamicForm;
